export default __webpack_public_path__ + "static/start-e3b05c5eac75df9e03d32e2007f312e2.png";